import { useRef } from 'react'
import Html5QrcodePlugin from '../html5-qrcode-plugin/Html5QrcodePlugin'
import { QrcodeErrorCallback, QrcodeSuccessCallback } from 'html5-qrcode/core'
import { Mtds } from 'prove-common'
import type { Html5QrcodeResult } from 'html5-qrcode'
import { CodeTypes, isValidCode } from '../../utils/codeValidation'

interface ProveScanProps {
  type: CodeTypes | null
  onScan: (sampleId: string) => void
}

export const ProveScan = ({ type, onScan }: ProveScanProps) => {
  const scannerActiveRef = useRef(true)

  const onScanSuccess: QrcodeSuccessCallback = (
    _decodedText: string,
    html5Result: Html5QrcodeResult
  ) => {
    if (!scannerActiveRef.current) return
    if (isValidCode(html5Result.result, type)) {
      scannerActiveRef.current = false
      const sampleId = html5Result.result.text
      onScan(sampleId)
      setTimeout(() => {
        scannerActiveRef.current = true
      }, 5000)
    }
  }

  const onScanFailure: QrcodeErrorCallback = (error) => {
    console.log('Scan failure:', error)
  }

  return (
    <Mtds.Card className='w-full h-96 p-0 overflow-hidden'>
      <Html5QrcodePlugin
        fps={10}
        qrbox={(w, h) => ({ width: Math.min(w, h), height: Math.min(w, h) })}
        qrCodeSuccessCallback={onScanSuccess}
        qrCodeErrorCallback={onScanFailure}
        fullScreen={false}
      />
    </Mtds.Card>
  )
}
